module.exports = {
  DAILY_REPORT: 'daily_report',
  WEEKLY_REPORT: 'weekly_report',
  CUSTOMER_CARE_TICKET: 'ticket',
  APPOINTMENT_CREATE: 'appt_create',
  APPOINTMENT_PARTICIPANT: 'appt_participant',
  APPOINTMENT_EDIT: 'appt_edit',
  APPOINTMENT_CANCELED: 'appt_canceled',
  APPOINTMENT_PARTICIPANT_CANCELED: 'appt_participant_canceled',
  APPOINTMENT_REMINDER: 'appt_reminder'
}
